import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Products from "../Products";
import "../../css/Cards/CardProducts.css";
import ChevronRight from "../../svg/ICON_chevronRight_Dark.svg";
import Image from "../ImageElement";
import { List } from "immutable";
import _ from "lodash";
/**
 * CardProducts component
 */
class CardProducts extends React.Component {
  static displayName = "CardProducts";
  static propTypes = {
    className: PropTypes.string,
    productCats: PropTypes.object,
    title: PropTypes.string,
    children: PropTypes.node,
    screen: PropTypes.string,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "CardProducts";
    this.popper = null;
    this.products = null;
    this.button = null;
    this.card = null;
    this.descriptions = [];
    this.state = {
      openCat: -1,
      maxHeightLine: new List(),
    };
    this.toggleCat = this.toggleCat.bind(this);
    this.calculateHeight = this.calculateHeight.bind(this);
  }

  /**
   * Display / Hide products pan
   * @param  {Number} ID Category ID
   */
  toggleCat(ID) {
    if (this.state.openCat === ID) {
      this.setState({ openCat: -1 });
      setTimeout(() => {
        this.card.style["marginBottom"] = null;
      }, 100);
    } else {
      this.setState({ openCat: ID });
      setTimeout(() => {
        this.card.style["marginBottom"] = this.products.offsetHeight + "px";
      }, 100);
    }
  }

  /**
   * @override
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.screen === "mobile") {
      console.log("RESET MinHeight");
      this.descriptions = [];
      this.setState({ maxHeightLine: new List() });
    }
  }

  componentDidMount() {
    const maxes = [];
    _.each(this.descriptions, (ref, index) => {
      const lineIndex = (index / 2) | 0;
      let localmax = 0;
      if (maxes[lineIndex]) localmax = maxes[lineIndex];
      else maxes.push(0);
      const max = this.calculateHeight(ref, index);
      if (max > localmax) {
        maxes[lineIndex] = max;
      }
    });
    this.setState({ maxHeightLine: new List(maxes) });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.maxHeightLine.size === this.state.maxHeightLine.size) return;
    const maxes = [];
    _.each(this.descriptions, (ref, index) => {
      const lineIndex = (index / 2) | 0;
      let localmax = 0;
      if (maxes[lineIndex]) localmax = maxes[lineIndex];
      else maxes.push(0);
      const max = this.calculateHeight(ref, index);
      if (max > localmax) {
        maxes[lineIndex] = max;
      }
    });
    this.setState({ maxHeightLine: new List(maxes) });
  }
  /**
   * A new reference is inserted in the dom, set the height.
   *
   * @param {DOMELement} ref
   * @param {Number} height
   */
  calculateHeight(ref, index) {
    return parseInt(window.getComputedStyle(ref).height, 10);
  }

  /**
   * @override
   */
  render() {
    // console.log('render state is ', this.state.maxHeightLine.toJS());
    return (
      <div
        className={`${this.className} ${this.props.className || ""}`}
        ref={(ref) => (this.card = ref)}
      >
        <div className={`${this.className}__title`}>{this.props.title}</div>
        <div className={`${this.className}__text`}>
          <div dangerouslySetInnerHTML={{ __html: this.props.children }} />
        </div>
        <div className={`${this.className}__categories `}>
          {this.props.productCats.map((cat, index) => {
            const lineIndex = (index / 2) | 0;
            return (
              <div
                className={`${this.className}__category ${
                  this.state.openCat === cat.ID
                    ? "open"
                    : this.state.openCat !== -1
                    ? "close"
                    : ""
                }`}
                key={cat.ID}
              >
                <div className="image">
                  <Image
                    alt={cat.thumbnail().alt}
                    src={cat.thumbnail().desktop_src}
                  />
                </div>
                <div className="title">{cat.Title}</div>
                <div
                  className="content"
                  style={
                    this.state.maxHeightLine.has(lineIndex)
                      ? {
                          minHeight:
                            this.state.maxHeightLine.get(lineIndex) + "px",
                        }
                      : {}
                  }
                  ref={(ref) => {
                    if (!ref || this.descriptions[index]) {
                      return;
                    }
                    this.descriptions.push(ref);
                  }}
                  dangerouslySetInnerHTML={{ __html: cat.Content }}
                />
                {cat.products().size > 0 && (
                  <div className="products__container">
                    <div
                      className="btn"
                      onClick={() => this.toggleCat(cat.ID)}
                      ref={(ref) => (this.button = ref)}
                    >
                      <a>
                        Liste des produits
                        <img src={ChevronRight} className="icon" alt=">" />
                      </a>
                    </div>
                    <div
                      className={
                        "products" +
                        (this.state.openCat === cat.ID ? " open" : "")
                      }
                      ref={(prod) => (this.products = prod)}
                    >
                      <Products products={cat.products()} category={cat} />
                      <Link
                        className={`${this.className}__action`}
                        to="/new-offer"
                      >
                        Demander une offre
                        <img src={ChevronRight} className="icon" alt=">" />
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default CardProducts;



// WEBPACK FOOTER //
// ./src/components/Cards/CardProducts.js